/**
 * Attribution badge required by the Indian Kanoon API Terms & Conditions
 * (https://api.indiankanoon.org/terms/) whenever IK search results,
 * documents, or document fragments are shown to a user.
 *
 * The ToS requires the "Powered by IKanoon" graphic shown above search
 * results / in a prominent location for RAG use — full, unaltered, never
 * partially covered. The image renders straight from IK's own hosted CDN
 * so we never modify or re-host the asset.
 *
 * Sizing: kept compact (h-5 desktop / h-4 mobile) so it sits cleanly above
 * dense legal-data lists without dominating the layout. Renders WITHOUT
 * a hyperlink wrapper — the IK ToS does not explicitly require the badge
 * to be a clickable link, and the surrounding context already provides
 * navigation to IK content.
 */
export default function PoweredByIKanoonBadge({ placement = "top", className = "" }) {
    return (
        <div
            className={`flex items-center ${placement === "top" ? "border-b border-zinc-200 dark:border-zinc-800 pb-2 mb-3" : ""} ${className}`}
            data-testid="powered-by-ikanoon"
        >
            <picture>
                {/* Mobile (≤ 640px) variant — narrower asset to fit phone widths */}
                <source
                    media="(max-width: 640px)"
                    srcSet="https://api.indiankanoon.org/static/pics/ikanoon_mobile_powered_transparent.png"
                />
                {/* Desktop / default */}
                <img
                    src="https://api.indiankanoon.org/static/pics/ikanoon6_powered_transparent.png"
                    alt="Powered by IKanoon (Indian Kanoon)"
                    className="h-4 sm:h-5 w-auto select-none opacity-90"
                    loading="lazy"
                    draggable={false}
                />
            </picture>
        </div>
    );
}
